import { mapState } from 'vuex'
import moment from 'moment'
import { isHiddenHeaderFn, debounce } from '@/utils/utils'
import { multiply } from '@/utils/math'
import { currencyList } from '@/utils/constBase'

const mixin = {
  props: {
    isTab: { type: Boolean, default: false },
    commonForm: { type: Object, default: () => ({}) },
  },
  data() {
    const regex = /^([1-9][\d,，]*(\.\d*)?)$|^(0\.0*[1-9]+)$/
    return {
      formVal: {
        time: null,
        originCurrencyCode: undefined,
        destCurrencyCode: undefined,
        money: '1.00',
      },
      // 费率
      rate: 0,
      // 是否展示
      isShow: false,
      originRate: {},
      destRate: {},
      undertake: {
        NTD: 'TWD',
      },
      regex,
      filterProp: 'children',
      minLimit: '2009-01-01',
      format: 'yyyy-MM-DD HH:mm:ss',
      debounceTimer: null,
      rules: {
        time: [
          {
            required: true,
            message: this.$t('common.form.pleaseSelect'),
          },
        ],
        money: [
          {
            required: true,
            message: this.$t(
              'serviceSupport.querySupport.exce_rates.moneyInvalid'
            ),
            trigger: ['change', 'blur'],
          },
          // 监控平台上 移动端上报的 ‘请输入有效金额’ 的问题
          {
            required: true,
            validator: this.validator,
            message: this.$t(
              'serviceSupport.querySupport.exce_rates.moneyInvalid'
            ),
            trigger: ['change', 'blur'],
          },
          {
            validator: this.validatorReg,
            message: this.$t(
              'serviceSupport.querySupport.exce_rates.moneyExceed'
            ),
            trigger: ['change', 'blur'],
          },
        ],
        originCurrencyCode: [
          {
            required: true,
            message: this.$t('common.form.pleaseSelect'),
          },
        ],
        destCurrencyCode: [
          {
            required: true,
            message: this.$t('common.form.pleaseSelect'),
          },
        ],
      },
    }
  },
  computed: {
    ...mapState({
      locale: (state) => state.locale,
      resizeInfo: (state) => state.resizeInfo,
      site: (state) => state.site,

    }),
    isHiddenHeader() {
      return isHiddenHeaderFn(this.$route)
    },
    showBasic() {
      return (
        this.isShow &&
        Object.keys(this.originRate).length &&
        Object.keys(this.destRate).length
      )
    },
    originCurrencyList() {
      return this.filterCurrencyList(this.formVal.destCurrencyCode)
    },
    destCurrencyList() {
      return this.filterCurrencyList(this.formVal.originCurrencyCode)
    },
    rotaTotal() {
      return this.rotaTotalCount()
    },
    isEnEnv() {
      return this.locale.includes('en')
    },
    isMoneyPlural() {
      return (this.handlerMoneyValue(this.formVal?.money) || 0) - 0 !== 1
    },
    isTotalPlural() {
      return (this.handlerMoneyValue(this.rotaTotal) || 0) - 0 !== 1
    },
    currencyList() {
      // 需要过滤出的币种
      const filterCurrencyList =  currencyList
      return filterCurrencyList
    },
  },
  created() {
    const date = this.initDate()
    this.formVal.time = moment(date)
  },
  watch: {
    formVal: {
      handler(nv) {
        this.onValuesChange(nv)
      },
      deep: true,
    },
    'commonForm.time'(nv) {
      if (nv) {
        this.formVal.time = moment(nv)
      } else {
        // 重置时回到今天
        this.formVal.time = moment(this.initDate())
      }
    },
  },
  beforeDestroy() {
    // 清理定时器防止内存泄漏
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  },
  methods: {
    initDate() {
      return moment().format('YYYY-MM-DD')
    },
    validator(rule, value, callback) {
      const val = typeof rule === 'string' ? rule : value
      if (!this.regex.test(this.handlerMoneyValue(val))) {
        callback &&
          callback(
            new Error(
              this.$t('serviceSupport.querySupport.exce_rates.moneyInvalid')
            )
          )
        return false
      } else {
        callback && callback()
        return true
      }
    },
    validatorReg(rule, value, callback) {
      const val = typeof rule === 'string' ? rule : value
      if (
        !/^([1-9][\d,，]{0,10}(\.\d*)?)$|^(0\.0*[1-9]+)$/.test(
          this.handlerMoneyValue(val)
        )
      ) {
        callback &&
          callback(
            new Error(
              this.$t('serviceSupport.querySupport.exce_rates.moneyExceed')
            )
          )
        return false
      } else {
        callback && callback()
        return true
      }
    },
    splitNum(str) {
      const list = str.split('.')
      const int = list[0].split('').reverse().join('')
      const result = int
        .replace(/(\d{3})/g, '$1,')
        .split('')
        .reverse()
        .join('')
        .replace(/^,([\d.,]+)$/, '$1')
      return `${result}${list[1] ? `.${list[1]}` : ''}`
    },
    handlerMoneyValue(money) {
      let result = money
      if (/[,，]/.test(result)) {
        result = result.replace(/[,，]/g, '')
      }
      if (/\.$/.test(result)) {
        result = result.replace(/\.$/, '')
      }
      return result
    },
    rotaTotalCount() {
      if (this.regex.test(this.formVal.money) && this.rate) {
        const money = this.handlerMoneyValue(this.formVal.money)
        return this.splitNum(parseFloat(multiply(money, this.rate)).toFixed(4))
      }
      return 0
    },
    disabledDate(current) {
      const minLimit = moment(this.minLimit)
      const maxLimit = moment()
      return (
        (minLimit && current < minLimit) || (maxLimit && current > maxLimit)
      )
    },
    moneyInput() {
      this.$refs.form.validate('money')
    },
    moneyBlur() {
      this.formVal.money = this.splitNum(
        parseFloat(
          this.handlerMoneyValue(this.formVal.money)
        ).toFixed(2)
      )
    },
    filterCurrencyList(code) {
      return this.currencyList
        .filter((it) => it.value !== code)
        .map((it) => {
          it.label = `${this.$t(it.il8nName)} ${
            this.undertake[it.value] || it.value
          }`
          return it
        })
    },
    // 任一表单域的值发生改变时的回调
    onValuesChange: debounce(function (values) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      this.debounceTimer = setTimeout(() => {
        this.getData(values)
      }, 0)
    }, 1000),
    // 获取参数
    getParams(changeParams = {}) {
      const prevParams = this.formVal
      const params = Object.assign({}, prevParams, changeParams)
      params.money = parseFloat(
        this.handlerMoneyValue(prevParams.money)
      ).toFixed(2)
      params.time = moment(params.time).hour(7).minute(30).second(0).format(this.format)
      return params
    },
    inputComplete(params) {
      for (const [, val] of Object.entries(params)) {
        if (val === undefined || val === null || val === '') {
          this.isShow = false
          return false
        }
      }
      return true
    },
    query(params, callback) {
      this.$API.support.getExrateDestApi(params).then((res) => {
        callback && callback(res)
      })
    },
    // 获取数据
    getData(changeParams) {
      const params = this.getParams(changeParams)
      const complete = this.inputComplete(params)
      if (complete) {
        this.$refs.form
          ?.validate()
          .then(() => {
            this.query(params, (res) => {
              if (res?.exchangeRate && res?.swapExchangeRate) {
                this.isShow = true
                this.rate = res?.exchangeRate || 0
                this.basicOriginExchange(params, res.exchangeRate)
                this.basicDestExchange(params, res.swapExchangeRate)
                // this.formVal.money = this.splitNum(
                //   parseFloat(
                //     this.handlerMoneyValue(this.formVal.money)
                //   ).toFixed(2)
                // )
              } else {
                this.isShow = false
              }
            })
          })
          .catch(() => {
            this.isShow = false
          })
      }
    },
    swap() {
      const reversal = Object.assign({}, this.formVal, {
        originCurrencyCode: this.formVal.destCurrencyCode,
        destCurrencyCode: this.formVal.originCurrencyCode,
      })
      this.$set(this, 'formVal', reversal)
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text
        ?.toLowerCase()
        ?.includes(input?.toLowerCase())
    },
    basicOriginExchange(params, rate) {
      const basic = Object.assign({}, params, { money: 1 })
      this.originRate = {
        rate,
        money: basic.money,
        originCurrencyCode:
          this.undertake[basic.originCurrencyCode] || basic.originCurrencyCode,
        destCurrencyCode:
          this.undertake[basic.destCurrencyCode] || basic.destCurrencyCode,
      }
    },
    basicDestExchange(params, swapRate) {
      const reversal = Object.assign({}, params, {
        money: 1,
        originCurrencyCode: params.destCurrencyCode,
        destCurrencyCode: params.originCurrencyCode,
      })
      this.destRate = {
        rate: swapRate,
        money: reversal.money,
        originCurrencyCode:
          this.undertake[reversal.originCurrencyCode] ||
          reversal.originCurrencyCode,
        destCurrencyCode:
          this.undertake[reversal.destCurrencyCode] ||
          reversal.destCurrencyCode,
      }
    },
  },
}

export default mixin
